import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import ValueField from "../../../components/forms/ValueField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class EditProductSurchargeForm extends Component {

  render() {
    let {errors, handleSubmit, submit, surcharge, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    let removeLabel = submitting ? "Standby..." : "Remove"; 
    
    let currencyFields = surcharge.map(x => {
      return (
        <Field 
          key={x.get("currency")}
          label={x.get("currency")}
          name={`surcharge[${x.get("currency")}]`}
          serverError={this.props.errors.surcharge}
          component={TextInputField}
          normalize={numerical}
          />
      )
    });

    let stateCodeInput = null;
    if (this.props.showStateProvince) {
      stateCodeInput = <ValueField
        label="State"
        value={this.props.stateName}
        />
      }


    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <ValueField
              label="Country"
              value={this.props.countryName}
              />
            {stateCodeInput}       
            {currencyFields}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton onClick={handleSubmit(values => this.props.onRemove(values))} label={removeLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

EditProductSurchargeForm.defaultProps = {
  showStateProvince: false
}

const ReduxForm = reduxForm({
  form: "EditProductSurchargeForm"
})(EditProductSurchargeForm);

export default ReduxForm;